<div class="loader-container" [ngStyle]="containerStyle">
  <div class="loader" [ngStyle]="loaderStyle">Loading...</div>
</div>
